import CardOrderMenu from './CardOrderMenu';

export default CardOrderMenu;
